import { render, staticRenderFns } from "./codegoogle.vue?vue&type=template&id=48228b97&scoped=true&"
import script from "./codegoogle.vue?vue&type=script&lang=js&"
export * from "./codegoogle.vue?vue&type=script&lang=js&"
import style0 from "./codegoogle.vue?vue&type=style&index=0&id=48228b97&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48228b97",
  null
  
)

export default component.exports